<template>
    <div class="background">
        <div class="title">
            出厂激活成功
        </div>
        <div class="device-number">
            {{ boxNumber }} (编号: {{ boxTag }})
        </div>
        <a-icon
            class="ok-icon"
            theme="filled"
            type="check-circle" />
        <div class="note">
            激活成功
        </div>
        <div class="note-second">
            请把货柜二维码{{ cupboardNumber }}粘贴到玻璃门左上角位置
        </div>
        <div class="bottom-button-area">
            <div
                v-on:click="ok"
                class="button">
                完成
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';

 export default {
     name: 'BindOK',
     data() {
         return {
             boxNumber: "",
             cupboardNumber: "",
             boxTag: ""
         }
     },
     props: {
     },
     components: {
     },
     mounted() {
         this.boxNumber = sessionStorage.getItem("bindDeviceNumber")
         this.cupboardNumber = sessionStorage.getItem("bindCupboardNumber")
         this.boxTag = sessionStorage.getItem("bindBoxTag")
     },
     methods: {
         ok() {
             this.$router.replace("/home")

             sessionStorage.setItem("bindDeviceNumber", "")
             sessionStorage.setItem("bindCupboardNumber", "")
             sessionStorage.setItem("bindBoxTag", "")
         }
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     position: relative;
 }

 .title {
     font-size: 30px;
     padding-top: 40px;
 }

 .device-number {
     font-size: 20px;
     font-weight: bold;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .ok-icon {
     margin-top: 30%;
     margin-bottom: 20px;
     font-size: 100px;
     color: #09BB07;
 }

 .note {
     font-size: 20px;
 }

 .note-second {
     font-size: 16px;
     margin-top: 10px;
 }

 .bottom-button-area {
     width: 100%;
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     justify-content: center;
 }

 .button {
     width: 50%;
     background-color: #20273E;
     height: 40px;
     border-radius: 50px;
     color: white;
     font-size: 15px;
     border: none;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }
</style>
